import React from 'react'

import { HeaderActionButton, HeaderActionIcon, HeaderActionText, HeaderActionButtonDisabled } from '../headeractions/HeaderActions.styles'

import Icon from '@emcm-ui/component-icon';
import { SVGIcon } from '@emcm-ui/component-icon/lib/svg';

const DynamicHeaderButtonComponent = ({ events, label, icon, selectedRows, minimumSelected }) => {
  if (minimumSelected > 0 && selectedRows.length < minimumSelected) {
    return (
      <HeaderActionButtonDisabled data-testid='tool-button'>
        <HeaderActionIcon data-testid='tool-button-dynamic-header'>
        <SVGIcon name={icon} size="s" fill="#b2b2b2"/>
        
        </HeaderActionIcon>
        <HeaderActionText>
          {label}
        </HeaderActionText>
      </HeaderActionButtonDisabled>
    )
  }
  return (
    <HeaderActionButton onClick={events.handleClick} data-testid='tool-button'>
      <HeaderActionIcon data-testid='tool-button-dynamic-header'>
      <SVGIcon name={icon} size="s" fill="#4d4d4d" />
      
      </HeaderActionIcon>
      <HeaderActionText>
        {label}
      </HeaderActionText>
    </HeaderActionButton>
  )
}

export default DynamicHeaderButtonComponent
